import { useState, useEffect, useMemo } from 'react';
import dynamic from 'next/dynamic';

import { useRouter } from 'next/router';

import { useLocalStorage } from '@uidotdev/usehooks';

import { ZOOM_LOCAL_STORAGE_KEY } from '@lib/zoom/constants';

const Zoom = dynamic(
  () => import('./Zoom'),
  { ssr: false }
);

const HiddenZoomComponent = () => {
  const router = useRouter();

  const [start, setStart] = useState();

  const [zoom, setZoom] = useLocalStorage(ZOOM_LOCAL_STORAGE_KEY, {});

  useEffect(() => {
    if (zoom?.type === 'join' && router.pathname === '/streams/[streamId]/ros' && router.query?.streamId === zoom?.liveStreamId) {
      setStart(true);
    } else if (zoom?.type === 'leave' && start) {
      setStart(false);
    }
  }, [zoom?.type, router.pathname]);

  // Memoize zoom props to prevent unnecessary re-renders
  const zoomProps = useMemo(() => {
    if (!zoom) return null;

    return {
      meetingId: zoom.meetingId,
      password: zoom.pwd,
      liveStreamId: zoom.liveStreamId,
      tk: zoom.tk,
      botName: zoom.botName,
      platformId: zoom.platformId,
      isHost: zoom.isHost,
      resourceType: zoom.resourceType,
      isEduAccount: zoom.isEduAccount
    };
  }, [
    zoom?.meetingId,
    zoom?.pwd,
    zoom?.liveStreamId,
    zoom?.tk,
    zoom?.botName,
    zoom?.platformId,
    zoom?.isHost,
    zoom?.resourceType,
    zoom?.isEduAccount
  ]);

  return (
    <>
      {start && (
        <Zoom
          {...zoomProps}
          setRender={() => setZoom(undefined)}
        />
      )}
    </>
  );
};

export default HiddenZoomComponent;
